import React from 'react';
import '../Styles/terms_condition.css';

const TermsConditions = () => {
  return (
    <div className="terms-page-wrapper">
      <div className="terms-container">
        <h1 className="terms-title">
          Terms &amp; <span className="terms-title-highlight">Conditions</span>
        </h1>

        <p className="terms-intro">
          Welcome to Vanakkam HRD By accessing or using this website, you agree to the following Terms &amp; Conditions.
        </p>

        <section className="terms-section">
          <h2 className="terms-heading">Acceptance of Terms</h2>
          <p className="terms-text">
            Please read these terms carefully before using the online payment facility. Using the online payment facility on this website indicates that you accept these terms. If you do not accept these terms do not use this facility.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">Website Usage</h2>
          <p className="terms-text">
           You agree to use this website only for lawful purposes and not engage in any activity that may disrupt or damage the website or its services.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">Event Registration</h2>
          <ul className="terms-list">
            <li>⁠Event registrations are subject to availability.</li>
            <li>⁠Registration fees, if applicable, are non-transferable unless otherwise stated.</li>
            <li>⁠Vanakkam HRD reserves the right to modify event schedules, speakers, venues, or agendas without prior notice</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">Intellectual Property</h2>
          <p className="terms-text">
            All website content, including logos, text, images, videos, designs, and trademarks, is the property of Vanakkam HRD and may not be copied, reproduced, or distributed without prior written permission.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">User Information</h2>
          <p className="terms-text">
           You are responsible for providing accurate information while registering for events or submitting forms. False or misleading information may result in cancellation of your registration.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">Privacy</h2>
          <p className="terms-text">
            Your personal information is collected and processed in accordance with our Privacy Policy.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">Limitation of Liability</h2>
          <p className="terms-text">
            Vanakkam HRD shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of this website or participation in our events.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">External Links</h2>
          <p className="terms-text">
             This website may contain links to third-party websites. Vanakkam HRD is not responsible for the content, privacy practices, or services offered by those websites.</p>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">Changes to Terms</h2>
          <p className="terms-text">
           Vanakkam HRD reserves the right to update these Terms & Conditions at any time. Continued use of the website constitutes acceptance of the revised terms.
          </p>
        </section>

        <section className="terms-section terms-section-last">
          <h2 className="terms-heading">Contact Us</h2>
          <p className="terms-text">
           For any questions regarding these Terms & Conditions, please contact us through the 
            Contact Us: support@vanakkamhrd.com
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsConditions;